import React, { PureComponent } from 'react';

import Animate from 'react-move/Animate';
import { quadOut } from '../../helper/utils';

class Bar extends PureComponent {
  render() {
    return (
      <Animate
        start={{ width: 0 }}
        enter={{ width: this.props.width }}
        update={{
          width: [this.props.width],
          timing: { duration: 300, quadOut }
        }}
      >
        {state => (
          <rect
            className="bar"
            x={this.props.x}
            y={this.props.y}
            height={this.props.height}
            width={state.width}
            fill={this.props.fill}
          />
        )}
      </Animate>
    );
  }
}

export default Bar;



// WEBPACK FOOTER //
// ./src/components/BarChart/bar.js